// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"922a5cbfe3f8e25c","6983":"53e2a3b31477ca62"}[chunkId] + ".css";
};